module.exports = __webpack_public_path__ + "img/3.2.ba908c85.svg";